import { Component } from '@angular/core';
import { ReportGetter } from '../../directives/ReportGetter';
import { ReportBuilderService } from '../../services/report-builder.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { FileService } from '../../../../shared/services/file.service';
import { GuardService } from '../../../../shared/services/guard.service';
import { ModuleService } from '../../../../shared/services/module.service';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../../current-project';
import { TinyHelper } from '../../../../shared/helpers/tiny.helper';

@Component({
    selector: 'app-report-one-pager',
    templateUrl: './report-one-pager.component.html',
    styleUrls: ['./report-one-pager.component.scss'],
    standalone: false
})
export class ReportOnePagerComponent extends ReportGetter {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    constructor(
        builder: ReportBuilderService,
        dialog: MatDialog,
        router: Router,
        navigation: NavigationService,
        guard: GuardService,
        moduleService: ModuleService,
        private fileService: FileService
    ) {
        super(builder, dialog, router, navigation, guard, moduleService);
    }

    protected isGuidanceOpen(id: string): boolean {
        return this.builder.guidanceRef.some(e => e.id === id);
    }

    /**
     * Downloads the attachment from the server.
     * If the document is a File, it will not be downloaded as it means it was uploaded in the current session.
     */
    protected async downloadAttachment(): Promise<void> {
        const document = this.documents[0];
        if (document instanceof File) {
            return;
        }

        // Old attachments use name instead of id
        const key = document.id ? `${document.id}.pdf` : document.name;
        const report = await this.fileService.getReportDocument(this.report.id, key);
        await this.fileService.downloadAttachment(report, document.name);
    }

    protected uploadAttachment(documents: FileList): void {
        const pdfDocuments = Array.from(documents).filter(file => file.type === 'application/pdf');
        this.documents = pdfDocuments.length > 0 ? [pdfDocuments[0]] : [];
    }

    protected removeAttachment(): void {
        this.documents = [];
    }

    protected getFileLastModifiedDate(): Date {
        const document = this.documents[0];
        if (document instanceof File) {
            return new Date(document.lastModified);
        }
        return null;
    }

    protected getFileSize(): string {
        return TinyHelper.convertBytesToMB(this.documents[0].size);
    }
}
